export const environment = {
    production: false,
    ENV: 'alpha',
    SITE_URL: 'https://alpha.dotblack.co.za',
};
